<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"> </app-loading-state>

<ng-template #loadedContent>
	<div class="invitations-container">
		<div class="content">
			<ng-container *ngIf="organisationInvitations.length; else noInvitations">
				<ng-container *ngFor="let invitation of organisationInvitations">
					<app-organisation-invitation-banner [organisationInvitation]="invitation" />
				</ng-container>
			</ng-container>

			<ng-template #noInvitations>
				<app-alert
					content="You currently have no organisation invitations. If you were expecting an invitation, please contact your organisation administrator."
				></app-alert>
			</ng-template>
		</div>
	</div>
</ng-template>
